import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
function RoleProfileTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    self.CompleteCheck = function () {
        return true;
    };
    self.SelectedRoleId = ko.observable();
    self.SelectedRoleProfile = ko.observable();
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.EnableToolbarButtons();
    });
    self.Role = parent;
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGridRoleProfile();
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGridRoleProfile();
    });
    self.RoleProfileCollection = ko.observableArray([]);
    self.SelectedRoleProfileRow = ko.observable({});
    var _deleteMessageRoleProfile = Bao.Session.GetMessage("msgDeleteRoleProfile");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "RoleProfileAdd":
                self.ShowRoleProfileDialog(self.Role.RoleId(), null, true);
                break;
            case "RoleProfileEdit":
                if (self.SelectedRoleProfileRow() != null) {
                    self.ShowRoleProfileDialog(self.Role.RoleId(), self.SelectedRoleProfileRow().RoleProfile, false);
                }
                break;
            case "RoleProfileDelete":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageRoleProfile, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteRoleProfile(self.SelectedRoleProfileRow().RoleProfile);
                    }
                });
                break;
        }
    };
    self.RefreshGridRoleProfile = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/RoleTab/GetRoleProfileCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedRoleProfileRow(null);
            self.TotalRows(0);
            self.RoleProfileCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.RoleProfileCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddRoleProfile = function (model, roleId) {
        tabPage.IsLoading(true);
        Bao.post("Uadm/RoleTab/AddRoleProfile", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            model: ko.toJS(model),
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGridRoleProfile();
        });
    };
    self.DeleteRoleProfile = function (roleProfile) {
        return Bao.post("Uadm/RoleTab/DeleteRoleProfile", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleProfile: roleProfile
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGridRoleProfile();
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("800px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                var shouldReturn = false;
                if (self.Dialog.ViewModel().IsNewRoleProfile()) {
                    $.each(self.RoleProfileCollection(), function (index, item) {
                        if (item.RoleProfile == self.Dialog.ViewModel().RoleProfile()) {
                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("ProfileNameExists"), "info");
                            shouldReturn = true;
                        }
                    });
                }
                if (shouldReturn) {
                    return;
                }
                if (!Bao.Utils.String.IsNullOrEmpty(self.Dialog.ViewModel().RoleProfile())) {
                    self.Dialog.IsLoading(true);
                    self.AddRoleProfile(self.Dialog.ViewModel(), self.Role.RoleId());
                    self.Dialog.Close();
                    self.Dialog.IsLoading(false);
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowRoleProfileDialog = function (roleId, roleProfile, isNew) {
        return Bao.post("Uadm/RoleTab/ShowRoleProfileDialog", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: roleId,
            roleProfile: roleProfile,
            isNew: isNew
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.SelectedRoleProfile.subscribe(function () {
        if (self.SelectedRoleProfile() != null) {
            var myModel = {
                RoleId: self.SelectedRoleProfile().RoleId,
                RoleProfile: self.SelectedRoleProfile().RoleProfile,
                RoleProfileValue: self.SelectedRoleProfile().RoleProfileValue,
                IsInherited: false
            };
            self.AddRoleProfile(myModel, self.Role.RoleId());
        }
    });
    self.SelectedRoleProfileRow.subscribe(function () {
        self.EnableToolbarButtons();
    });
    self.EnableToolbarButtons = function () {
        $.each(self.ToolbarButtons(), function (index, item) {
            if (item.ActionKey() == "RoleProfileDelete" || item.ActionKey() == "RoleProfileEdit") {
                if (self.SelectedRoleProfileRow() != null && (self.SelectedRoleProfileRow().IsInherited == null || self.SelectedRoleProfileRow().IsInherited == false)) {
                    item.Enabled(true);
                }
                else {
                    item.Enabled(false);
                }
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/RoleTab/ResetRoleProfile", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGridRoleProfile().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function (savetime) {
        return Bao.post("Uadm/RoleTab/SaveRoleProfileCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: savetime
        }));
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("Uadm/RoleTab/CopyRoleProfileCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
    self.loaded = function () {
        self.RefreshGridRoleProfile();
    };
}
export default RoleProfileTabModel;